import React from "react";

const NavbarItem = (props) => {
  return <div className="o-navbar__nav-item">{props.children}</div>;
};

export default NavbarItem;
